import { memo } from "react";
import classNames from "classnames";
import { Amount } from "@design-system/Amount/Amount";
import { MatchCountChip } from "@components/accounting/transactionMatch/MatchCountChip";
import styles from "./AccrualMatchPreview.module.scss";

interface AccrualMatchPreviewProps {
    counterpartyName: string | null;
    extraCounterpartyCount: number;
    amount: number;
    countLabel: string;
    isSuggested?: boolean;
}

export const AccrualMatchPreview = memo(
    ({
        counterpartyName,
        extraCounterpartyCount,
        amount,
        countLabel,
        isSuggested,
    }: AccrualMatchPreviewProps) => (
        <div
            className={classNames(styles.container, {
                [styles.suggested]: isSuggested,
            })}
        >
            {counterpartyName && (
                <span className={styles.counterparty} title={counterpartyName}>
                    {counterpartyName}
                </span>
            )}
            {extraCounterpartyCount > 0 && (
                <span className={styles.extraNamesChip}>
                    +{extraCounterpartyCount}
                </span>
            )}
            <span className={styles.amount}>
                <Amount amount={amount} />
            </span>
            <MatchCountChip label={countLabel} isSuggested={isSuggested} />
        </div>
    ),
);

AccrualMatchPreview.displayName = "AccrualMatchPreview";
